const styles = theme => ({
  tooltip: theme.mixins.gutters({
    margin: 0,
    lineHeight: '24px',
    border: '1px solid #f5f5f5',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '10px'
  }),
  label: theme.mixins.gutters({
    margin: 0,
    color: '#666',
    fontWeight: 700
  }),
  value: theme.mixins.gutters({
    margin: 0,
    fontWeight: 200
  }),
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  failStateBadge: {
    color: theme.palette.fail,
  },
  passStateBadge: {
    color: theme.palette.success,
  },
  pairResultTable:{
    '& th': {
      fontWeight: 900,
      color: 'rgba(0, 0, 0, 0.87)',
    },
    '& th, td': {
      padding: '4px 30px 4px 24px',
    }
  }

})

export default styles
